// @ts-nocheck

import React from 'react';

import styles from './barcode.module.scss';
import { getBarcodeBorderColor, getTicketBackgroundColor } from '@/v2/helpers/ticketColors/ticketColorsHelper.ts';
import RotatingOrStaticBarcode from './rotatingOrStaticBarcode.tsx';
import VoidedBarcode from '@/v2/wallet/items/barcode/voidedBarcode.tsx';
import NoBarcode from '@/v2/wallet/items/barcode/noBarcode.tsx';
import { EventModel } from '@/v2/models/eventModel.ts';
import { TicketModel } from '@/v2/models/ticketModel.ts';
import BarcodeNotYetActive from '@/v2/wallet/items/barcode/barcodeNotYetActive.tsx';
import { RedemptionAvailabilityModel } from '@/v2/models/multiEventEnvelopeModel.ts';

type Props = {
  activeToken: string;
  ticket: TicketModel;
  event: EventModel;
  redemptionAvailability: RedemptionAvailabilityModel;
};

const Barcode = ({ ticket, activeToken, redemptionAvailability }: Props) => {
  const { shouldNotShowBarcode } = ticket;
  const ticketBarcodeClassNames = `${styles.ticketBarcode} ${shouldNotShowBarcode ? styles.ticketBarcodeLinkTickets : styles.ticketBarcodeBarcode}`;

  const outerBarcodeBackgroundColor = getTicketBackgroundColor(ticket);
  const barcodeBorderColor = getBarcodeBorderColor(ticket);

  function renderBarcodeComponent() {
    if (ticket.voidedAt != null) {
      return <VoidedBarcode />;
    }
    if (shouldNotShowBarcode) {
      return redemptionAvailability.redemptionDisabled ? (
        <BarcodeNotYetActive activeToken={activeToken} />
      ) : (
        <NoBarcode activeToken={activeToken} />
      );
    }
    return <RotatingOrStaticBarcode itemTicket={ticket} />;
  }

  return (
    <section
      className={ticketBarcodeClassNames}
      style={{ backgroundColor: outerBarcodeBackgroundColor, borderColor: barcodeBorderColor }}
    >
      {renderBarcodeComponent()}
    </section>
  );
};

export default Barcode;
